/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./proxy-athlete.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./proxy-athlete.component";
import * as i3 from "@angular/router";
import * as i4 from "../../services/filters-athlete-general.service";
var styles_ProxyAthleteComponent = [i0.styles];
var RenderType_ProxyAthleteComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ProxyAthleteComponent, data: {} });
export { RenderType_ProxyAthleteComponent as RenderType_ProxyAthleteComponent };
export function View_ProxyAthleteComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [], null, null, null, null, null))], null, null); }
export function View_ProxyAthleteComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-proxy-athlete", [], null, null, null, View_ProxyAthleteComponent_0, RenderType_ProxyAthleteComponent)), i1.ɵdid(1, 114688, null, 0, i2.ProxyAthleteComponent, [i3.Router, i3.ActivatedRoute, i4.FiltersAthleteGeneralService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ProxyAthleteComponentNgFactory = i1.ɵccf("app-proxy-athlete", i2.ProxyAthleteComponent, View_ProxyAthleteComponent_Host_0, {}, {}, []);
export { ProxyAthleteComponentNgFactory as ProxyAthleteComponentNgFactory };
